import React, { useState, useRef, useEffect } from "react";
import More from "../../img/more.svg";

export type Status = {
  label: string;
  value: string;
  color: string;
};

type Props = {
  statuses: Status[];
  defaultStatus?: string; 
  onChange?: (status: Status) => void;
};

const StatusDropdown: React.FC<Props> = ({ statuses, defaultStatus, onChange }) => {

 const initialStatus =
    statuses.find((s) => s.value === defaultStatus) || statuses[0];

  const [selected, setSelected] = useState<Status>(initialStatus);
  const [open, setOpen] = useState(false);
  const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
  const ref = useRef<HTMLDivElement>(null);

  const updateMenuPosition = () => {
    if (!ref.current) {
      return;
    }

    const dropdownRect = ref.current.getBoundingClientRect();
    const viewportMargin = 8;
    const menuWidth = 210;
    const estimatedMenuHeight = statuses.length * 37 + 16;
    const availableBelow = window.innerHeight - dropdownRect.bottom;
    const availableAbove = dropdownRect.top;
    const openUp =
      availableBelow < estimatedMenuHeight && availableAbove > availableBelow;
    const preferredTop = openUp
      ? dropdownRect.top - estimatedMenuHeight - 4
      : dropdownRect.bottom + 4;
    const maxTop = window.innerHeight - estimatedMenuHeight - viewportMargin;
    const top = Math.max(viewportMargin, Math.min(preferredTop, maxTop));
    const right = Math.max(
      viewportMargin,
      window.innerWidth - dropdownRect.right
    );

    setMenuStyle({
      position: "fixed",
      top,
      right,
      width: menuWidth,
      zIndex: 2000,
    });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!open) {
      return;
    }

    const handleResize = () => updateMenuPosition();
    const handleScroll = () => setOpen(false);

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [open, statuses.length]);

  return (
    <div className="dropdown status-dropdown" ref={ref}>
      <button
        className={`btn btn-sm p-0 status-btn1 br-0 dropdown-toggle btn1-${selected.color}`}
        onClick={() => {
          if (!open && ref.current) {
            updateMenuPosition();
          }
          setOpen(!open);
        }}
      >
      <img src={More} width={20}/>
      </button>

      <ul
        className={`dropdown-menu status-dropdown-menu ${open ? "show" : ""}`}
        style={menuStyle}
      >
        {statuses.map((status) => (
          <li key={status.value}>
            <button
               className={`dropdown-item1 btn btn-sm btn-secondary btn-${status.color}`}
              onClick={() => {
                setSelected(status);
                setOpen(false);
                onChange?.(status);
              }}
            >
              {status.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StatusDropdown;
